@if (isVisible()) {
    <div class="overlay">
        <ng-content></ng-content>
    </div>
}
